import { IUpdateTermoUseCase } from "../../../presentation/useCases/update/update_termo_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateTermoUseCase
 */

export class UpdateTermoUseCase implements IUpdateTermoUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idTermo: number,
    codigo?: string,
    descricao?: string,
    nome?: string,
    ativo?: boolean
  ): Promise<void> {
    await this.repository.updateTermo(
      idTermo,
      codigo,
      descricao,
      nome,
      ativo
    );
  }

}
